import RouteList from "@components/Routes/RouteList";

const MainContent = () => (
  <div className="flex-1 pt-10 px-8 overflow-scroll">
    <RouteList />
  </div>
);

export default MainContent;
